import { render, staticRenderFns } from "./SalonMasivo.vue?vue&type=template&id=88a11248&"
import script from "./SalonMasivo.vue?vue&type=script&lang=js&"
export * from "./SalonMasivo.vue?vue&type=script&lang=js&"
import style0 from "./SalonMasivo.vue?vue&type=style&index=0&id=88a11248&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports